import {
  type HomeCarouselProps,
  useHomeCarouselController,
} from "./HomeCarousel.controller";
import { HomeCarouselPresentation } from "./HomeCarousel.pres";

export const HomeCarousel = ({ margin }: HomeCarouselProps) => {
  const props = useHomeCarouselController({ margin });

  return <HomeCarouselPresentation {...props} />;
};
